import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { ComponentStylingInterface, TeamHeroMenuComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const TeamHeroMenuStyling = ({ component, onChange }: ComponentStylingInterface<TeamHeroMenuComponentInterface>) => {
  const { t } = useTranslation();

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          type: 'boolean',
          path: 'customStyling.topSpace',
          label: t('pagebuilder:top-space'),
        },
        {
          type: 'color',
          path: 'customStyling.ItemTextColor',
          label: t('pagebuilder:heromenu-text-color'),
        },
        {
          type: 'color',
          path: 'customStyling.menuBackgroundColor',
          label: t('pagebuilder:heromenu-background-color'),
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable component={component} onChange={onChange} sections={settingSections} showTitleAndDescription={false} />;
};
export default React.memo(TeamHeroMenuStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
